(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-slideshow-backup-20260802-asfo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-gms-element-aura-carousel]').forEach(function(carousel) {
      var slides = carousel.querySelectorAll('[data-gms-element-aura-slide]');
      if (slides.length < 2) return;
      var index = 0;
      setInterval(function() {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, 2000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-slideshow-backup-20260802-links"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-gms-element-aura-carousel]').forEach(function(carousel) {
      var slides = carousel.querySelectorAll('[data-gms-element-aura-slide]');
      if (slides.length < 2) return;
      var index = 0;
      setInterval(function() {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, 8000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-slideshow-backup-20260802-second"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-gms-element-aura-carousel]').forEach(function(carousel) {
      var slides = carousel.querySelectorAll('[data-gms-element-aura-slide]');
      if (slides.length < 2) return;
      var index = 0;
      setInterval(function() {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, 2000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-gms-element-aura-carousel]').forEach(function(carousel) {
      var slides = carousel.querySelectorAll('[data-gms-element-aura-slide]');
      if (slides.length < 2) return;
      var index = 0;
      setInterval(function() {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, 8000);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
